import React, { Suspense } from 'react'
import ReactDOM from 'react-dom'

import * as sentry from './helpers/sentry'

sentry.init()

let App: React.LazyExoticComponent<React.ComponentType<any>>

const params = new URLSearchParams(window.location.search)

if (params.has('client-identity')) {
    App = React.lazy(() => import('./applications/ThirdParty'))
} else {
    App = React.lazy(() => import('./applications/Main'))
}

ReactDOM.render(
    <Suspense fallback={null}>
        <App />
    </Suspense>,
    document.getElementById('root'),
)
